import { render } from "./Bestsellers.vue?vue&type=template&id=828e71ae&scoped=true"
import script from "./Bestsellers.vue?vue&type=script&lang=js"
export * from "./Bestsellers.vue?vue&type=script&lang=js"

import "./Bestsellers.vue?vue&type=style&index=0&id=828e71ae&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-828e71ae"]])

export default __exports__